import React from 'react'
import GooglePlacesAutocomplete, {geocodeByPlaceId} from 'react-google-places-autocomplete';

interface ISearchBarViewModel {
  onSelectLocation: (lat: number, lng: number) => void
}

const SearchBarView: React.FC<ISearchBarViewModel> = (props) => (
  <div>
    <img style={{width: 20, height: 20, position: 'absolute', zIndex: 999, top: 9, left: 8}} src='/search.svg' />
    <GooglePlacesAutocomplete
      apiKey='AIzaSyDrp9cfe22w4lmSru9GbKveLw4fwRmb7fM'
      selectProps={{
        styles: colourStyles,
        placeholder: 'Search for location',
        onChange: (val: any) => {
          console.log(val)
          geocodeByPlaceId(val.value.place_id)
            .then(results => {
              console.log(results)
              if (results.length > 0) {
                const location = results[0].geometry.location
                props.onSelectLocation(location.lat(), location.lng())
              }
            })
            .catch(error => console.error(error));
        }
      }}
    />
  </div>
)

export default SearchBarView

const dot = (color = 'transparent') => ({
  alignItems: 'center',
  display: 'flex',

  ':before': {
    backgroundColor: color,
    borderRadius: 10,
    // content: '" "',
    content: '"  "',
    display: 'block',
    marginRight: 8,
    height: 16,
    width: 16,
  },
});

const colourStyles = {
  control: (styles: any) => ({ ...styles, backgroundColor: 'white', borderRadius: 10, borderBottomRightRadius: 0, borderBottomLeftRadius: 0 }),
  input: (styles: any) => ({ ...styles, ...dot() }),
  placeholder: (styles: any) => ({ ...styles, ...dot() }),
  singleValue: (styles: any, { data }: any) => ({ ...styles, ...dot() }),
};
